import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const ClientAPI = {
	getClient: (request: GetClientRequest) => {
		return axios
			.get(`${apiUrl}/clients/${request.clientId}`)
			.then((response) => response.data as ClientDTO);
	},
	// client site methods
	getClientSiteClient: (request: GetClientSiteClientRequest) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/clients/${request.clientId}`
			)
			.then((response) => response.data as ClientDTO);
	},
	upsertClientSiteClient: (request: UpsertClientSiteClientRequest) => {
		return axios
			.post(`${clientApiUrl}/clients`, request)
			.then((response) => response.data as ClientDTO);
	},
	getClientSiteClients: (datasetId: number) => {
		return axios
			.get(`${clientApiUrl}/datasets/${datasetId}/clients`)
			.then((response) => response.data as ClientDTO[]);
	},
};

export default ClientAPI;
